const watchType = Symbol();

export class Watch {
    [watchType]: any;
    medicines: string[];
    meals: string[];
    lifestyleAndEnvironments: string[];
    carestaffs: string[];
    others: string[];

    constructor(
        medicines: string[],
        meals: string[],
        lifestyleAndEnvironments: string[],
        carestaffs: string[],
        others: string[],
    ) {
        this.medicines = medicines;
        this.meals = meals;
        this.lifestyleAndEnvironments = lifestyleAndEnvironments;
        this.carestaffs = carestaffs;
        this.others = others;
    }
}
